<template>
  <el-container>
    <el-main style="padding: 0; width: 100vh">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="snMaterialSnRules"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button v-if="(selection.length > 0 && limits.delAuth)" type="danger" @click="deleteBatch">批量删除</el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="标签编号">
              <el-input v-model.trim="filter.materialSnRuleNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规则编号">
              <el-input v-model.trim="filter.snRuleNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="标签状态">
              <el-select v-model="filter.status" placeholder="请选择" clearable>
                <el-option v-for="item in snStatus" :key="item.code" :label="item.name" :value="item.code"/>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
      <material-sn-rule-edit ref="editPage" :sn-status="snStatus" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import MaterialSnRuleEdit from "@/views/information/MaterialSnRule/MaterialSnRuleEdit";

  export default {
    name: "MaterialSnRuleList",
    components: {MaterialSnRuleEdit, ViewTable},
    data() {
      return {
        limits: {
          addAuth: this.$auth(153),
          editAuth: this.$auth(154),
          delAuth: this.$auth(155),
        },
        columnsProperty: [
          {
            key: "materialSnRuleNo",
            align: "left",
            width: 100,
            tooltip: true,
          },
          {
            key: "materialNo",
            align: "left",
            minWidth: 120,
            tooltip: true,
          },
          {
            key: "materialName",
            align: "left",
            minWidth: 300,
            tooltip: true,
          },
          {
            key: "snRuleNo",
            align: "center",
            width: 100,
          },
          {
            key: "snRuleExpression",
            align: "left",
            minWidth: 240,
            tooltip: true,
          },
          {
            key: "snVersion",
            align: "center",
            width: 80,
          },
          {
            key: "statusName",
            align: "center",
            width: 80,
          },
          {
            key: "creatorName",
            align: "center",
            width: 80,
          },
          {
            key: "action",
            align: "center",
            width: 140,
            slot: "action",
            fixed: "right",
          },
        ],
        snStatus: [],
        selection: [],
        searchShow: false,
        filter: {
          materialSnRuleNo: "",
          materialNo: "",
          snRuleNo: "",
          materialName: "",
          status: "",
        },
      };
    },
    mounted() {
      this.getRuleStatus();
    },

    methods: {
      // 查询
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      // checkBox
      selectHandle(selection) {
        this.selection = selection;
      },

      // 获取状态
      getRuleStatus() {
        this.$http.get("basic", "dictionaries/dictEnum/CommonStatus").then((resp) => {
          if (resp.success) {
            this.snStatus = resp.data;
          }
        });
      },

      // 单个删除
      deleteHandle(row) {
        this.$http.delete("basic", "snMaterialSnRules", row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
          }
        });
      },

      // 批量删除
      deleteBatch() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkid);
        });
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "snMaterialSnRules/batchDelete", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
